import { currentBackend } from '../backend';
import { addNotification, clearNotifications } from './notifications';
import { refilterConfigForPermissions } from './config';
import { stopDeployNotifications } from './deployStatus';
// Generic, backend-agnostic hook: any backend's resolved user may carry a
// `permissions` field describing what the just-authenticated user is allowed
// to access (decap-cms-backend-turbo-github is the first backend to set it, but the
// field name itself must stay backend-neutral — core doesn't know or care
// which backend it came from, it just re-filters the loaded config once
// it's present).
function dispatchPermissionsRefilterIfPresent(dispatch, user) {
  const permissions = user.permissions;
  if (permissions) {
    dispatch(refilterConfigForPermissions(permissions));
  }
}
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const AUTH_REQUEST_DONE = 'AUTH_REQUEST_DONE';
export const USE_OPEN_AUTHORING = 'USE_OPEN_AUTHORING';
export const LOGOUT = 'LOGOUT';
export function authenticating() {
  return {
    type: AUTH_REQUEST
  };
}
export function authenticate(userData) {
  return {
    type: AUTH_SUCCESS,
    payload: userData
  };
}
export function authError(error) {
  return {
    type: AUTH_FAILURE,
    error: 'Failed to authenticate',
    payload: error
  };
}
export function doneAuthenticating() {
  return {
    type: AUTH_REQUEST_DONE
  };
}
export function useOpenAuthoring() {
  return {
    type: USE_OPEN_AUTHORING
  };
}
export function logout() {
  return {
    type: LOGOUT
  };
}

// Check if user data token is cached and is valid
export function authenticateUser() {
  return (dispatch, getState) => {
    const state = getState();
    const backend = currentBackend(state.config);
    dispatch(authenticating());
    return Promise.resolve(backend.currentUser()).then(user => {
      if (user) {
        if (user.useOpenAuthoring) {
          dispatch(useOpenAuthoring());
        }
        dispatch(authenticate(user));
        dispatchPermissionsRefilterIfPresent(dispatch, user);
      } else {
        dispatch(doneAuthenticating());
      }
    }).catch(error => {
      dispatch(authError(error));
      dispatch(logoutUser());
    });
  };
}
export function loginUser(credentials) {
  return (dispatch, getState) => {
    const state = getState();
    const backend = currentBackend(state.config);
    dispatch(authenticating());
    return backend.authenticate(credentials).then(user => {
      if (user.useOpenAuthoring) {
        dispatch(useOpenAuthoring());
      }
      dispatch(authenticate(user));
      dispatchPermissionsRefilterIfPresent(dispatch, user);
    }).catch(error => {
      console.error(error);
      dispatch(addNotification({
        message: {
          details: error.message,
          key: 'ui.toast.onFailToAuth'
        },
        type: 'error',
        dismissAfter: 8000
      }));
      dispatch(authError(error));
      dispatch(doneAuthenticating());
    });
  };
}
export function logoutUser() {
  return (dispatch, getState) => {
    const state = getState();
    const backend = currentBackend(state.config);
    // Before backend.logout(), which discards the backend's deploy watcher.
    // The deploy-notification subscriptions are module-level singletons, so
    // leaving them set means startDeployNotifications() early-returns on the
    // next sign-in — and signing straight back in is the ordinary flow, since
    // Turbo's dashboard session outlives CMS logout — while the surviving
    // unsubscribe closures still point at the discarded watcher. The next save
    // then builds a fresh watcher with no listeners: it polls
    // site_deployments for up to the ledger's 20 minutes with nobody to tell,
    // and the editor gets a "Publishing…" toast that can never resolve.
    stopDeployNotifications();
    Promise.resolve(backend.logout()).then(() => {
      dispatch(logout());
      dispatch(clearNotifications());
    });
  };
}